import { useState } from "react";
import { TableBody } from "react-aria-components";

import { Link } from "@/components/link";
import { Cell, Column, Row, Table, TableHeader } from "@/components/table";
import { FeaturePageLayout } from "@/features/shared/layout";

import { categoryLabel } from "../category-labels";
import { useMbcCatalog } from "../design-types/hooks/useMbcCatalog";

export function SubCategoriesPage() {
  const [search, setSearch] = useState("");
  const { data: catalog, error, isLoading } = useMbcCatalog();

  const subCategories = (catalog?.subCategories ?? []).filter(({ name }) =>
    name.toLowerCase().includes(search.trim().toLowerCase()),
  );

  return (
    <div className="p-xl">
      <FeaturePageLayout
        isLoading={isLoading}
        searchBar={{ inputValue: search, setInputValue: setSearch }}
        title="Subcategories"
      >
        <div className="rounded-b-xl bg-bg-primary">
          {error && (
            <p className="px-xl pb-4 text-sm text-text-error" role="alert">
              Could not load the subcategories: {error.message}
            </p>
          )}
          <Table aria-label="Subcategories">
            <TableHeader>
              <Column defaultWidth={80} id="id" minWidth={80}>
                ID
              </Column>
              <Column defaultWidth="3fr" id="name" isRowHeader minWidth={200}>
                Name
              </Column>
              <Column defaultWidth="2fr" id="category" minWidth={140}>
                Category
              </Column>
              <Column defaultWidth="1fr" id="designTypes" minWidth={120}>
                Design types
              </Column>
            </TableHeader>
            <TableBody
              items={subCategories}
              renderEmptyState={() => (
                <p className="p-3xl text-sm text-text-tertiary">
                  No subcategories found.
                </p>
              )}
            >
              {(subCategory) => (
                <Row id={subCategory.id}>
                  <Cell>
                    <span className="whitespace-nowrap font-mono text-text-tertiary">
                      {subCategory.id}
                    </span>
                  </Cell>
                  <Cell>
                    <Link
                      className="font-medium text-text-primary"
                      href={`/admin/subcategories/${subCategory.id}`}
                    >
                      {subCategory.name}
                    </Link>
                  </Cell>
                  <Cell>{categoryLabel(subCategory.category)}</Cell>
                  <Cell>{subCategory.designTypes.length}</Cell>
                </Row>
              )}
            </TableBody>
          </Table>
        </div>
      </FeaturePageLayout>
    </div>
  );
}
